import React from 'react';
import { BsLinkedin, BsWhatsapp, BsGithub, BsBehance } from 'react-icons/bs';


const SocialMedia = () => (
  // return (
    <div className="app__social">
        <div>
            <a href={"https://github.com/teejaywurld"} target="_blank" rel="noopener noreferrer"><BsGithub /></a>
        </div>
        <div>
            <a href={"https://www.linkedin.com/in/adetunji-henry/"} target="_blank" rel="noopener noreferrer"><BsLinkedin /></a>
        </div>
        <div>
            <a href={"https://web.whatsapp.com/+2347032199678"} target="_blank" rel="noopener noreferrer"><BsWhatsapp /></a>
        </div>
        <div>
            <a href={"https://www.behance.net/adetunjihenry"} target="_blank" rel="noopener noreferrer"><BsBehance /></a>
        </div>
    </div>
  );

export default SocialMedia;
